import React from "react";
import {
  Box,
  Typography,
  Paper,
} from "@mui/material";

export const DefensePlaybook = () => {
  return (
    <Box sx={{ width: "100%" }}>
      <Paper
        sx={{
          bgcolor: "#1e1e1e",
          color: "rgba(255, 255, 255, 0.8)",
          p: 4,
          textAlign: "center",
        }}
      >
        <Typography variant="h5" sx={{ mb: 2 }}>
          Defense Playbook
        </Typography>
        <Typography variant="body1">
          The defense playbook component will be implemented here. It will follow the same styling pattern as the offense component.
        </Typography>
      </Paper>
    </Box>
  );
}; 